import Navbar from "../components/Navbar";
import Pricing from "../components/Pricing";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function PricingPage() {
    return (
        <div className="bg-background text-foreground min-h-screen">
            <Navbar />
            <main data-testid="pricing-page" className="pt-[7rem]">
                <Pricing />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
